import Lyrics from '@/components/musicPlayer/Lyrics'
import Transcripts from '@/components/musicPlayer/Transcripts'

const LyricsSection = ({ song, showAllTags, relatedSongs, currentTime, activeSong }) => {
    return (
        <div className={'flex-1 w-full  h-[600px]' + (showAllTags ? ' mb-20' : '') + (relatedSongs && relatedSongs.length === 0 ? ' mb-20' : '')}>
            <div className='relative bg-white/5 dark:bg-pink-300/5 flex flex-col justify-center items-center backdrop-blur-sm rounded-2xl p-6 lg:p-8'>
                <div className='absolute top-2 left-1 flex items-center gap-1 text-sm text-gray-400/40 dark:text-slate-600'>
                    <span>Created at:</span>
                    <span>{new Date(song?.date_time).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    })}</span>
                </div>
                {song?.lyrics?.length > 5 ? (
                    <h2 className='text-2xl font-bold text-white dark:text-slate-800 mb-6'>Lyrics</h2>
                ) : (
                    <h2 className='text-2xl font-bold text-white dark:text-slate-800 mb-6'>No lyrics available for this song.</h2>
                )}
                {song?.lyrics?.length > 5 ? (
                    <div className='max-w-none tracking-wider'>
                        {song?.song_id === activeSong?.song_id && song?.transcript?.length > 0 ?
                            <Transcripts currentTime={currentTime?.toFixed(0)} transcript={song?.transcript} />
                            :
                            <Lyrics lyrics={song?.lyrics} />
                        }
                    </div>
                ) : (
                    <div className='text-center lg:min-w-[400px] md:h-[600px] h-[300px] flex flex-col justify-center items-center max-w-2xl text-white'>
                        <p className='text-lg mb-4'>Unleash Your Imagination!</p>
                        <p className='text-lg mb-6'>
                            The lyrics for this AI-generated song are waiting to be discovered. As an AI music generation platform, we encourage you to let your creativity flow and interpret the melody in your own unique way.
                        </p>
                        <p className='text-sm text-gray-400'>
                            Dive into the world of AI-powered music and create your own lyrical masterpiece!
                        </p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default LyricsSection
